import React, { useState } from "react";
import "../assets/Css/ToggleSwitch.css";

const ToggleSwitch = ({status,setChecked,handleToggle,checked}) => {
  
  
  
  setChecked(status ? true : false);
  console.log("status-",status,"checked--",checked)


  return (
    <div
      className={`toggle-btn ${checked ? "active" : ""}`}
      onClick={handleToggle}
    >
      <input
        type="checkbox"
        className="cb-value"
        checked={checked}
        onChange={() => {}} 
      />
      <span className="round-btn"></span>
    </div>
  );
};

export default ToggleSwitch;
